import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import Content from "./content";

const Component = (props: any) => {
  const { status, setStatus, source } = props;
  const [isShow, setIsShow] = useState(false);
  useEffect(() => {
    if (status) {
      setTimeout(()=>setIsShow(true),100)
    } else {
      setIsShow(false);
    }
  }, [status]);
  return (
    <Modal
      width={1200}
      open={status}
      onCancel={() => {
        // setIsShow(false);
        setStatus(false);
        // setFlash([]);
      }}
      footer={null}
      // afterOpenChange={() => setTimeout(()=>setIsShow(true),100)}
      destroyOnHidden={true}
      title="混合物物性计算："
    >
      {/* <Select
            placeholder="切换物质"
            options={[
              { value: 1, label: "1" },
              { value: 2, label: "2" },
            ]}
          /> */}
      <Content source={source} isShow={isShow} />
    </Modal>
  );
};

export default Component;
